import { doRequest, HttpMethodEnum } from '../lib/httpHelper';
import { Service } from './service';

interface CouponCartItem {
  _id: string;
  price: number;
  quantity: number;
}

export default class CouponService extends Service {
  async getValidity(
    code: string,
    total: number,
    email: string,
    cartItems: CouponCartItem[],
    storeId?: string,
  ) {
    return await doRequest({
      auth: false,
      url: `${this.root}v2/coupon/validity`,
      method: HttpMethodEnum.POST,
      body: { code, total, email, cartItems, storeId },
    });
  }
}
